<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label class="control-label">{{ inputLabel }}</label>
    <div class="internal-comment-block">
      <div class="col-md-10">
        <input
          v-model="inputValue"
          id="internal-comment-input"
          type="text"
          placeholder="Внутренний комментарий"
          class="form-control"
          @blur="disableSaved"
        />
      </div>
      <div class="col-md-2">
        <button
          :disabled="disableButton"
          type="button"
          class="btn btn-success btn-primary-white hundred-percent-width"
          @click="addInternalComment"
        >Сохранить
        </button>
      </div>
      <div v-if="this.inputValue === this.oldValue && saved" class="col-md-12">Комментарий сохранен</div>
    </div>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import { ResponseStatuses } from '@/enums/ResponseStatuses'

export default {
  name: 'InternalCommentBlock',

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputName: {
      default: 'internal_comment'
    }
  },

  data() {
    return {
      oldValue: this.form.application.internal_comment,
      saved: false
    }
  },

  methods: {
    addInternalComment() {
      this.requestAddInternalComment(this.inputValue, this.form.application.id)
    },

    async requestAddInternalComment(internalComment, applicationId) {
      await ApiClient.addInternalCommentRequest({
        internal_comment: internalComment,
        application_id: applicationId
      }).then(response => {
        if (response.data.status === ResponseStatuses.Success) {
          this.oldValue = this.inputValue
          this.saved = true
        }
      })
    },

    disableSaved() {
      this.saved = false
    }
  },

  computed: {
    disableButton() {
      return this.inputValue === this.oldValue
    }
  }
}
</script>
